<template>
  <div style="position: relative;">
    <div class="integral isIncomplete" v-if="!isImproveInfo">
      <div class="integral-content" @click="showPointPopup">
        <div class="integral-left">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/recommend-icon2.png" alt=""/>
        </div>
        <div class="integral-text">
          预计获得{{ point }}积分
        </div>
        <div class="integral-right">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/question.png" alt=""/>
        </div>
      </div>
      <div class="perfect-info" @click="editInfo">
        <div>（请最晚于<span class="highlight-color">下船日前</span>至<span class="highlight-color">会员中心-完善信息</span>，</div>
        <div>需会员本人预订且出行可获得积分）</div>
      </div>
    </div>
    <div class="integral" v-else @click="showPointPopup">
      <div class="integral-content">
        <div class="integral-left">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/recommend-icon2.png" alt=""/>
        </div>
        <div class="integral-text">
          预计获得{{ point }}积分
        </div>
        <div class="integral-right">
          <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/question.png" alt=""/>
        </div>
      </div>
      <div class="perfect-info">（需会员本人预订且出行）</div>
    </div>
    <div class="point-popup" v-if="isShowPointPopup" @click="showPointPopup" :style="!isImproveInfo ? 'bottom: 38px' : 'bottom: 38px'">
      <div class="point-popup-content">
        积分可兑换<span>现金礼品卡</span>、限量皇家周边、大额船票立减券等，还可参与<span>免费船票抽奖</span>~
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    point: {
      default: ''
    },
    isImproveInfo:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      isShowPointPopup:false,
      shipCode:'',
      sailDate:''
    }
  },
  mounted() {
    let query = this.$route.query;
    if(query.shipCode && query.sailDate){
      this.shipCode = query.shipCode
      this.sailDate = query.sailDate
    }
  },
  methods: {
    showPointPopup(){
      this.isShowPointPopup = !this.isShowPointPopup
    },
    editInfo(){
      this.$emit('editInfo')
    }
  },
}
</script>
<style scoped lang="less">
.integral{
  width: 335px;
  height: 60px;
  background: url('https://resource.rcclchina.com.cn/wechatMiniProgram/global/member/completeInfoPointsBg.png') no-repeat;
  background-size: 100% 100%;
  margin: 10px auto 0;
  color: #592814;
  font-size: 13px;
  font-weight: 500;
  
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.integral.isIncomplete{
  width: 339px;
  height: 76px;
  background: url('https://resource.rcclchina.com.cn/wechatMiniProgram/global/member/incompleteInfoPointsBg.png') no-repeat;
  background-size: 100% 100%;
}
.integral-content{
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 2px 60px 0 46px;
  .integral-text{
    //width: 170px;
    //text-align-last: justify;
  }
}
.integral img{
  width: 100%;
  height: 100%;
  display: block;
}
.integral-left{
  width: 40px;
  height: 35px;
}
.integral-right{
  width: 14px;
  height: 14px;
  line-height: 14px;
}
.perfect-info{
  font-size: 12px;
  color: #AF936B;
}
.integral-perfect{
  width: 335px;
  height: 48px;
  background: url('https://resource.rcclchina.com.cn/wechatMiniProgram/recommend.png') no-repeat;
  background-size: 100% 100%;
  margin: 10px auto 0;
  gap: 4px;
  color: #592814;
  font-size: 13px;
  font-weight: 500;
  
  display: flex;
  align-items: center;
  justify-content: center;
}
.integral-perfect img{
  width: 100%;
  height: 100%;
}
.point-popup{
  background: url('https://resource.rcclchina.com.cn/wechatMiniProgram/point-popup.png') no-repeat;
  background-size: 100%;
  width: 238px;
  height: 203px;
  position: absolute;
  right: 76px;
}
.point-popup .point-popup-content{
  font-size: 14px;
  padding: 80px 27px 43px;
}
.point-popup .point-popup-content span{
  color: #006AB6;
}
.highlight-color {
  color: #006AB6
}
</style>